"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FlatTreeItem", {
    enumerable: true,
    get: function() {
        return FlatTreeItem;
    }
});
const _TreeItem = require("../TreeItem/TreeItem");
const FlatTreeItem = _TreeItem.TreeItem;
